import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "work_requests",
    object: "work_request",
    header: [
      { text: "", value: "is_read" },
      { text: "Nombres", value: "first_name" },
      { text: "Apellidos", value: "last_name" },
      { text: "Email", value: "email" },
      { text: "Ducumento/Pasaporte", value: "dni" },
      { text: "País", value: "country_id" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    options: {
      sortBy: ["_id"],
      sortDesc: [true],
    },
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters,
  },
};
